import DynamicLegal from "@/pages/legal/DynamicLegal";

export default function Returns() {
  return <DynamicLegal pageKey="returns" />;
}
